import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { EXTRA_TRANSLATIONS } from "./extraTranslations";

export const LANGUAGES = [
  { code: "tr", label: "Türkçe" },
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "pt", label: "Português" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "ja", label: "日本語" },
  { code: "zh", label: "中文" },
  { code: "ko", label: "한국어" },
  { code: "ru", label: "Русский" },
  { code: "ar", label: "العربية" },
  { code: "sv", label: "Svenska" },
  { code: "da", label: "Dansk" },
  { code: "no", label: "Norsk" },
  { code: "nl", label: "Nederlands" },
  { code: "el", label: "Ελληνικά" },
];

const TEXT = {
  tr: {
    brand: "FitDish",
    daily: "Günlük Plan",
    meals: "Yemekler",
    desserts: "Tatlılar",
    addRecipe: "Tarif Ekle",
    favorites: "Favoriler",
    shopping: "Alışveriş",
    dietitian: "Online Diyetisyen",
    signIn: "Giriş Yap",
    signOut: "Çıkış",
    language: "Dil",
    dailyIntro: "Lezzet ve sağlığın buluşma noktası.",
    allMealsIntro: "Öğün, mutfak, kategori ve kalori bilgileriyle tarifleri keşfedin.",
    dessertsIntro: "Sütlü, şerbetli, meyveli, fit ve dünya tatlılarını kalori bilgileriyle keşfedin.",
    all: "Tümü",
    healthy: "Sağlıklı",
    tasty: "Lezzetli",
    balanced: "Dengeli",
    fitHealthy: "Fit / Sağlıklı",
    breakfast: "Kahvaltı",
    lunch: "Öğle",
    dinner: "Akşam",
    dessert: "Tatlı",
    meal: "Öğün",
    category: "Kategori",
    cuisine: "Mutfak",
    allMealsFilter: "Tüm öğünler",
    allCuisines: "Tüm mutfaklar",
    allWorldCuisines: "Tüm dünya mutfakları",
    allDessertTypes: "Tüm tatlı türleri",
    dessertType: "Tatlı türü",
    newPlan: "Yeni plan",
    loadingDaily: "Günlük plan hazırlanıyor...",
    loadingMeals: "Yemekler yükleniyor...",
    loadingDesserts: "Tatlılar yükleniyor...",
    totalDailyCalories: "Bugünkü üç ana öğünün tahmini toplam kalorisi",
    cachedPlan: "Bugünün planı kayıttan getirildi.",
    noMealFound: "Yemek bulunamadı",
    noDessertFound: "Tatlı bulunamadı",
    tryDifferentFilters: "Filtreleri değiştirerek tekrar deneyin.",
    mealsFound: "yemek bulundu",
    dessertsFound: "tatlı bulundu",
    noSlotSuggestion: "Bu filtreler için öneri bulunamadı.",
    searchMeals: "Yemek, mutfak veya malzeme ara...",
    searchDesserts: "Tatlı veya malzeme ara...",
    minutes: "dk",
    kcal: "kcal",
    nutritionUnverified: "Besin değeri doğrulanmadı",
    verifiedPerServing: "Doğrulanmış / porsiyon",
    ingredientUnit: "malzeme",
    addOwnRecipe: "Kendi Tarifini Ekle",
    addRecipeIntro: "Kendi tarifinizi ekleyin; tarifiniz yönetici incelemesinden sonra yayına alınır.",
    addRecipeLoginNote: "Tarif eklemek için sosyal hesabınızla giriş yapmalısınız.",
    loginRequiredRecipe: "Tarif eklemek için giriş yapın.",
    recipeName: "Tarif adı",
    mealType: "Öğün",
    calories: "Kalori",
    caloriesOptional: "Kalori (opsiyonel)",
    caloriesAiPlaceholder: "Boş bırakırsan AI hesaplar",
    caloriesAiHint: "Gramajlı malzemeler USDA ile otomatik hesaplanır. Eksik eşleşmede AI tahmini kullanılır.",
    nutritionSummary: "Besin özeti",
    estimatedPerServing: "Tahmini / porsiyon",
    calculatedPerServing: "USDA hesabı / porsiyon",
    wholeRecipeNutritionSummary: "Tarif toplamı besin özeti",
    calculatedWholeRecipe: "USDA hesaplaması / tarif toplamı",
    yieldNotProvided: "Kaynak tarif porsiyon sayısı vermediği için porsiyon başı değer yayınlanmadı.",
    protein: "Protein",
    carbs: "Karbonhidrat",
    fat: "Yağ",
    fiber: "Lif",
    prepTime: "Hazırlık",
    cookTime: "Pişirme",
    prepMinutes: "Hazırlık (dk)",
    cookMinutes: "Pişirme (dk)",
    servings: "Porsiyon",
    ingredients: "Malzemeler",
    steps: "Tarif adımları",
    youtubeUrl: "YouTube video bağlantısı",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saveRecipe: "Tarifi Kaydet",
    saving: "Kaydediliyor...",
    recipeSaved: "Tarif kaydedildi",
    recipeSubmissionTermsTitle: "Paylaşım koşulları",
    recipeSubmissionTermsHint: "Tarifi gönderebilmek için iki beyan da zorunludur. Kabul kaydı tarifle birlikte saklanır.",
    recipeSubmissionTermsAccept: "Kullanım koşullarını okudum ve kabul ediyorum.",
    recipeCopyrightDeclarationAccept: "Paylaştığım tarif metni, görseller, video ve bağlantılar için gerekli haklara sahip olduğumu veya bunlari paylaşmaya yetkili olduğumu beyan ediyorum.",
    recipeSubmissionTermsRequired: "Tarif göndermeden önce kullanım koşullarını ve telif hakları beyanını onaylamalısınız.",
    ingredientsPlaceholder: "Her satıra: malzeme, gram. Örn: yumurta, 100",
    recipeIngredientGramHint: "USDA makroları için her malzemeyi ayrı satıra gram olarak yazın.",
    recipeIngredientGramRequired: "Her malzemeyi ayrı satıra malzeme, gram biçiminde yazın. Örnek: domates, 120",
    stepsPlaceholder: "Her satıra bir adım yazın",
    recipeNamePlaceholder: "Örn: Ev Usulü Sebzeli Makarna",
    rateRecipe: "Bu tarife puan ver",
    socialInfo: "Google ile giriş yapın veya admin paneli için tanımlı giriş kodunu kullanın.",
    favoriteAdd: "Favorilere ekle",
    favoriteRemove: "Favoriden çıkar",
    favoriteAdded: "Favorilere eklendi",
    favoriteRemoved: "Favorilerden çıkarıldı",
    back: "Geri",
    backToMeals: "Yemeklere Dön",
    noMealSelected: "Yemek seçilmedi",
    addAllIngredients: "Malzemeleri Listeye Ekle",
    addToList: "+ Liste",
    added: "Eklendi",
    alreadyOnList: "Zaten listede",
    ingredientAdded: "listeye eklendi",
    ingredientsAddedToShopping: "malzeme alışveriş listesine eklendi",
    videoRecipe: "Video Tarif",
    rateLoginRequired: "Puan vermek için sosyal giriş yapın",
    ratingSaved: "Puan kaydedildi",
    noRatingYet: "Henüz puan yok",
    dietitianIntro: "Her gün sağlıklı beslenme ve yaşam için kısa, uygulanabilir öneriler.",
    dailyNutritionAdvice: "Günlük beslenme ve yaşam önerisi",
    dailyTips: "Günün ipuçları",
    suggestedFoodToday: "Bugünün önerilen besini:",
    adviceLoading: "Günün önerisi hazırlanıyor...",
    adviceLoadFailed: "Öneri yüklenemedi",
    checkBackendOrKey: "Backend bağlantısını veya API anahtarını kontrol edin.",
    askDietitian: "Diyetisyene Sor",
    medicalDisclaimer: "Bu bölüm genel bilgilendirme içindir; kişisel tanı veya tedavi yerine geçmez.",
    askPlaceholder: "Örn: Akşam yemeğinde daha hafif ne tercih edebilirim?",
    answerPreparing: "Yanıt hazırlanıyor...",
    cannotAnswerNow: "Şu an yanıt veremiyorum. Lütfen biraz sonra tekrar deneyin.",
    wait: "Bekle",
    ask: "Sor",
    favoritesIntro: "Beğendiğiniz yemek ve tatlı tariflerine hızlıca ulaşın.",
    noFavorites: "Henüz favori tarif yok",
    favoriteHint: "Kartlardaki kalp ikonuna tıklayarak tarifleri favorilere ekleyebilirsiniz.",
    browseMeals: "Yemeklere Göz At",
    favoriteRecipeCount: "favori tarif",
    shoppingIntro: "Tariflerden eklediğiniz eksik malzemeleri kalıcı olarak takip edin.",
    list: "Liste",
    waiting: "bekliyor",
    completed: "tamamlandı",
    clearCompleted: "Tamamlananları Sil",
    emptyList: "Liste boş",
    shoppingEmptyHint: "Tarif detaylarından malzemeleri alışveriş listesine ekleyebilirsiniz.",
    purchased: "Satın Alınanlar",
    addNewIngredient: "Yeni malzeme ekle...",
    add: "Ekle",
    delete: "Sil",
    purchasedCleared: "Satın alınanlar temizlendi",
    ingredientSuggest: "Malzemeye Göre Öneri",
    ingredientSuggestIntro: "Elinizdekileri girin, size uygun tarifleri bulalım.",
    yourIngredients: "Elinizdeki Malzemeler",
    addIngredientPlaceholder: "Malzeme ekle (örn: domates, yumurta...)",
    searching: "Aranıyor...",
    findRecipe: "Tarif Bul",
    clear: "Temizle",
    searchingRecipes: "Tarifler aranıyor...",
    recipesFound: "tarif bulundu",
    noMatchingRecipe: "Eşleşen tarif bulunamadı",
    tryDifferentIngredients: "Farklı malzemeler deneyin.",
    match: "Eşleşme",
    availableIngredients: "malzeme mevcut",
    missingIngredients: "Eksik malzemeler:",
    addMissingToList: "Eksikleri Listeye Ekle",
    exactMatches: "Tam eşleşen tarifler",
    partialMatches: "Eksik malzemeli tarifler",
    aiIngredientHelp: "AI şef yorumu",
    aiIngredientResult: "AI şef yorumu",
    ingredientAiLocked: "AI destekli öneri kilitli",
    ingredientAiLockedHint: "Premium değilseniz ödüllü reklam izleyerek günlük en fazla 3 AI öneri hakkı kazanabilirsiniz.",
    ingredientAiRewardConfirm: "Ödüllü reklam simülasyonu izleyerek 1 AI malzeme önerisi hakkı kazanacaksınız. Devam edilsin mi?",
    watchAdForAi: "Reklam izle ve AI önerisi al",
    continueWith: "ile devam et",
    requestFailed: "İstek başarısız",
    translationQueued: "Tarif cevirisi arka planda hazirlaniyor; birazdan tekrar acildiginda tam ceviri gelir.",
    translationNeedsKey: "Tam tarif çevirisi için GROQ_API_KEY gerekli; kategori ve etiketler seçili dile çevrildi.",
    admin: "Admin",
    adminPanel: "Admin Paneli",
    adminPanelIntro: "Yeni kullanıcı tarifleri yönetici incelemesine gelir; uygun içeriği onaylayabilir veya reddedebilirsiniz.",
    adminAccessRequired: "Admin girişi gerekli",
    adminAccessHint: "Bu bölüm sadece ADMIN_EMAIL ile eşleşen hesaba acilir.",
    loading: "Yükleniyor...",
    refresh: "Yenile",
    status: "Durum",
    active: "Aktif",
    inactive: "Pasif",
    testUsersTitle: "Test Kullanıcıları",
    testUsersHint: "Google Play kapalı test sürecindeki kayıtlı kullanıcıların giriş ve son 14 günlük aktiflik durumunu takip edin.",
    testUsersFilter: "Filtre",
    testUserFilterall: "Tüm kullanıcılar",
    testUserFilteractive: "Aktif kullanıcılar",
    testUserFilterinactive: "Pasif kullanıcılar",
    testUserFilterrecent14: "Son 14 günde aktif olanlar",
    testUsersTotal: "Toplam kayıtlı kullanıcı",
    testUsersLoggedIn: "En az 1 kez giriş yapan",
    testUsersActive14: "Son 14 günde aktif",
    testUsersOpenSessions: "Oturumu açık hesap",
    testUsersNeverLoggedIn: "Hiç giriş yapmayan",
    testUserEmail: "E-posta",
    testUserId: "Kullanıcı ID",
    testUserFirstLogin: "İlk giriş",
    testUserLastActive: "Son aktiflik",
    testUserSessionCount: "Toplam oturum",
    testUserSessionStatus: "Oturum",
    testUserSessionOpen: "Açık",
    testUserSessionClosed: "Kapalı",
    testUserActiveDays14: "Son 14 gün aktif gün",
    noTestUsers: "Bu filtreye uygun test kullanıcısı yok.",
    pending: "Eski bekleyen",
    approved: "Yayında",
    rejected: "Yayından kaldırıldı",
    loadingRecipes: "Tarifler yükleniyor...",
    noModerationRecipes: "Incelenecek tarif yok",
    noModerationRecipesHint: "Bu durumda tarif bulunmuyor.",
    approve: "Yayına al",
    reject: "Yayından kaldır",
    preview: "On izle",
    recipeApproved: "Tarif yayına alındı",
    recipeRejected: "Tarif yayından kaldırıldı",
    unpublishRecipe: "Yayından kaldır",
    republishRecipe: "Yayına al",
    recipeUnpublished: "Tarif yayından kaldırıldı",
    recipeRepublished: "Tarif yeniden yayına alındı",
    recipePendingReview: "Tarif kaydedildi ve yönetici incelemesine gönderildi.",
    emailAddress: "E-posta adresi",
    displayName: "Görünen ad",
    recipeImage: "Tarif görseli",
    recipeImageHint: "JPG, PNG veya WEBP; en fazla 2 MB.",
    changeImage: "Görseli değiştir",
    recipeImageUpdated: "Tarif görseli güncellendi",
    recipeMediaUpdated: "Tarif medyası güncellendi",
    removeImage: "Ana görseli kaldır",
    removeVideo: "Videoyu kaldır",
    removeStepImages: "Adım görsellerini kaldır",
    recipeImageRemoved: "Ana görsel kaldırıldı",
    recipeVideoRemoved: "Video kaldırıldı",
    recipeStepImagesRemoved: "Adım görselleri kaldırıldı",
    saveChanges: "Değişiklikleri kaydet",
    recipeContentUpdated: "Tarif içeriği güncellendi",
    recipeContentRequired: "İçerik alanları boş bırakılabilir; kaydedince yayındaki metinler kaldırılır.",
    recipeSource: "Kaynak",
    sourceImageNotImported: "Kaynak görseli içe aktarılmadı.",
    themealdbImportTitle: "TheMealDB tarif aktarımı",
    themealdbImportHint: "Tarif metni ve malzemeleri resmi API'den alınıp Türkçe akışa uygun kaydedilir; TheMealDB görselleri alınmaz.",
    themealdbImportLetter: "Harf",
    themealdbImportLimit: "Adet",
    themealdbImportButton: "TheMealDB'den ekle",
    themealdbImportDone: "TheMealDB tarifleri eklendi",
    copyrightReportTitle: "Telif ihlali bildir",
    copyrightReportButton: "Telif ihlali bildir",
    copyrightReportHint: "Bu tarifte size ait olduğunu düşündüğünüz görsel, video veya metin varsa bize bildirebilirsiniz.",
    copyrightReportReviewNote: "Bildiriminiz teknik incelemeye alınır; inceleme sonucunda en geç 48 saat içinde ilgili içerik kaldırılır.",
    copyrightReporterName: "Ad soyad / kurum",
    copyrightReporterEmail: "E-posta adresiniz",
    copyrightIssueItems: "İhlale konu olan alanlar",
    copyrightIssueItemsPlaceholder: "Örn: ana görsel, video, adım görselleri, tarif metni",
    copyrightReferenceUrl: "Hak sahipliği / kaynak linki",
    copyrightDetails: "Açıklama",
    copyrightDetailsPlaceholder: "İhlali neden bildirdiğinizi kısaca açıklayın.",
    copyrightReportSubmit: "Bildirimi gönder",
    copyrightReportSubmitted: "Telif bildirimi alındı",
    copyrightReportRequired: "E-posta ve ihlale konu olan alanlar zorunlu.",
    copyrightReports: "Telif bildirimleri",
    copyrightReportsHint: "Hak sahibi bildirimleri burada takip edilir.",
    noCopyrightReports: "Yeni telif bildirimi yok.",
    markReviewing: "Incelemede",
    markRemoved: "Kaldirildi",
    markDismissed: "Geçersiz",
    close: "Kapat",
    legalTitle: "Gizlilik ve Yasal",
    legalOpen: "Sayfayı aç",
    legalProfileHint: "Gizlilik politikası, kullanım şartları, reklam tercihleri ve telif süreci.",
    legalIntro: "Bu sayfa uygulamanın veri kullanımı, reklam tercihleri, kullanıcı içerikleri ve telif bildirim sürecini özetler.",
    legalLastUpdated: "Son güncelleme: 19 Mayıs 2026",
    legalPrivacyTitle: "Gizlilik politikası ve KVKK aydınlatması",
    legalPrivacyBody: "Uygulama; hesap açma, tarif ekleme, yorum yapma, profil oluşturma, AI destekli özellikleri kullanma ve reklam tercihlerini yönetme sırasında ad, e-posta, profil bilgileri, boy-kilo, sağlık geçmişi, alerji, ilaç bilgisi, tarif metinleri, görseller, videolar ve kullanım tercihleri gibi verileri işleyebilir.",
    legalDataTitle: "Veriler hangi amaçla kullanilir?",
    legalDataBody: "Veriler hesap işlemleri, tarif ve yorum özellikleri, alışveriş listesi, favoriler, AI diyet asistanı, besin değeri tahmini, ödüllü reklam hakları, güvenlik, hata giderme ve hizmet kalitesini iyileştirme amaçlarıyla kullanılır.",
    legalAiTitle: "AI ve sağlık bilgileri",
    legalAiBody: "AI diyet asistanı tanı, tedavi veya kesin tıbbi karar vermez. Boy, kilo, sağlık geçmişi, alerji ve ilaç bilgileri yalnızca daha dikkatli genel beslenme önerileri üretmek için kısa bağlam olarak kullanılır.",
    legalAdsTitle: "Reklamlar ve reklam tercihleri",
    legalAdsBody: "Uygulamada Google AdMob üzerinden ödüllü reklamlar ve geçiş reklamlari kullanılabilir. Reklamlara izin veren ücretsiz kullanıcılar bazi AI ve analiz özelliklerini reklamlı haklarla kullanabilir. Canlı surumde reklam rıza yonetimi Google AdMob UMP akışı ile yapilmalidir; premium üyeler reklamsiz devam eder.",
    legalUserContentTitle: "Kullanıcı tarifleri ve içerik sorumlulugu",
    legalUserContentBody: "Tarif ekleyen kullanıcı, paylaştığı tarif metni, görsel, video, adım görselleri ve bağlantıların hukuka uygunluğundan sorumludur. Yeni kullanıcı tarifleri yönetici incelemesinden sonra yayına alınır.",
    legalThirdPartyRecipeTitle: "Ucuncu taraf tarif kaynaklari",
    legalThirdPartyRecipeBody: "TheMealDB gibi resmi API kaynaklarindan eklenen tariflerde kaynak bilgisi korunur. Bu kaynaklardan görsel içe aktarilmaz; görseller uygulama tarafında ayrıca üretilir veya yönetici tarafından eklenir.",
    legalCopyrightTitle: "Telif ihlali bildirim süreci",
    legalCopyrightBody: "Hak sahibi olduğunu düşünen kişiler tarif detay sayfasindaki Telif ihlali bildir butonuyla ana görsel, video, adım görselleri, tarif metni veya diğer alanları bildirebilir. Bildirim teknik incelemeye alınır; inceleme sonucunda en geç 48 saat içinde ilgili içerik kaldırılır.",
    legalRightsTitle: "Kullanıcı hakları ve iletişim",
    legalRightsBody: "Kullanıcılar verilerinin düzeltilmesini, silinmesini veya hesaplarının kapatılmasını talep edebilir. Bu talepler ve telif/içerik bildirimleri için uygulama yöneticisine veya destek iletişim adresine başvurulabilir.",
    legalDisclaimerTitle: "Yasal not",
    legalDisclaimerBody: "Bu metin uygulama içi bilgilendirme taslağıdır. Canlı yayın öncesinde gizlilik politikası, kullanım şartları, reklam rıza metni ve Google Play Data Safety beyanları birbiriyle uyumlu hale getirilmeli ve gerekirse hukuk uzmanı tarafından kontrol edilmelidir.",
    designSettings: "Tasarim Ayarlari",
    designSettingsIntro: "Uygulama başlığı, fontlar, punto, buton renkleri ve menü ikonlarını değiştirin.",
    interstitialAdMessage: "Geçiş reklamı simülasyonu. Gerçek mobil sürümde burada kısa bir geçiş reklamı gösterilecek.",
    appTitle: "Uygulama başlığı",
    bodyFont: "Genel yazi tipi",
    headingFont: "Başlık yazi tipi",
    baseFontSize: "Genel punto",
    headingScale: "Başlık ölçeği",
    buttonRadius: "Buton kose yuvarlakligi",
    primaryButtonColor: "Ana buton rengi",
    primaryButtonHover: "Ana buton hover rengi",
    successButtonColor: "Yesil buton rengi",
    buttonTextColor: "Buton yazi rengi",
    saveDesignSettings: "Tasarimi kaydet",
    designSettingsSaved: "Tasarim ayarlari kaydedildi",
  },
  en: {
    brand: "FitDish",
    daily: "Daily Plan",
    meals: "Meals",
    desserts: "Desserts",
    addRecipe: "Add Recipe",
    favorites: "Favorites",
    shopping: "Shopping",
    dietitian: "Online Dietitian",
    signIn: "Sign In",
    signOut: "Sign Out",
    language: "Language",
    dailyIntro: "Where flavor meets wellness.",
    allMealsIntro: "Explore recipes by meal, cuisine, category, and calories.",
    dessertsIntro: "Discover creamy, syrupy, fruity, fit, and world desserts with calorie details.",
    all: "All",
    healthy: "Healthy",
    tasty: "Tasty",
    balanced: "Balanced",
    fitHealthy: "Fit / Healthy",
    breakfast: "Breakfast",
    lunch: "Lunch",
    dinner: "Dinner",
    dessert: "Dessert",
    meal: "Meal",
    category: "Category",
    cuisine: "Cuisine",
    allMealsFilter: "All meals",
    allCuisines: "All cuisines",
    allWorldCuisines: "All world cuisines",
    allDessertTypes: "All dessert types",
    dessertType: "Dessert type",
    newPlan: "New plan",
    loadingDaily: "Preparing your daily plan...",
    loadingMeals: "Loading meals...",
    loadingDesserts: "Loading desserts...",
    totalDailyCalories: "Estimated total calories for today's three main meals",
    cachedPlan: "Today's plan was loaded from your saved plan.",
    noMealFound: "No meals found",
    noDessertFound: "No desserts found",
    tryDifferentFilters: "Change the filters and try again.",
    mealsFound: "meals found",
    dessertsFound: "desserts found",
    noSlotSuggestion: "No suggestion found for these filters.",
    searchMeals: "Search meal, cuisine, or ingredient...",
    searchDesserts: "Search dessert or ingredient...",
    minutes: "min",
    kcal: "kcal",
    nutritionUnverified: "Nutrition not verified",
    verifiedPerServing: "Verified / serving",
    ingredientUnit: "ingredients",
    addOwnRecipe: "Add Your Own Recipe",
    addRecipeIntro: "Add your own recipe; it is published after administrator review.",
    addRecipeLoginNote: "You must sign in with a social account before adding a recipe.",
    loginRequiredRecipe: "Sign in to add a recipe.",
    recipeName: "Recipe name",
    mealType: "Meal",
    calories: "Calories",
    caloriesOptional: "Calories (optional)",
    caloriesAiPlaceholder: "Leave blank for AI",
    caloriesAiHint: "Ingredients with gram amounts are calculated automatically with USDA. AI is used only when matching is incomplete.",
    nutritionSummary: "Nutrition summary",
    estimatedPerServing: "Estimated / serving",
    calculatedPerServing: "USDA calculation / serving",
    wholeRecipeNutritionSummary: "Whole-recipe nutrition summary",
    calculatedWholeRecipe: "USDA calculation / whole recipe",
    yieldNotProvided: "Per-serving values are not published because the source recipe does not provide a yield.",
    protein: "Protein",
    carbs: "Carbs",
    fat: "Fat",
    fiber: "Fiber",
    prepTime: "Prep",
    cookTime: "Cook",
    prepMinutes: "Prep (min)",
    cookMinutes: "Cook (min)",
    servings: "Servings",
    ingredients: "Ingredients",
    steps: "Steps",
    youtubeUrl: "YouTube video link",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saveRecipe: "Save Recipe",
    saving: "Saving...",
    recipeSaved: "Recipe saved",
    recipeSubmissionTermsTitle: "Submission terms",
    recipeSubmissionTermsHint: "Both declarations are required before submission. The acceptance record is stored with the recipe.",
    recipeSubmissionTermsAccept: "I have read and accept the terms of use.",
    recipeCopyrightDeclarationAccept: "I declare that I own the necessary rights to the recipe text, images, video, and links I share, or that I am authorized to share them.",
    recipeSubmissionTermsRequired: "Accept the terms of use and confirm the copyright declaration before submitting your recipe.",
    ingredientsPlaceholder: "Each line: ingredient, grams. Example: egg, 100",
    recipeIngredientGramHint: "Enter every ingredient on a separate line with its gram amount for USDA macros.",
    recipeIngredientGramRequired: "Write each ingredient on a separate line as ingredient, grams. Example: tomato, 120",
    stepsPlaceholder: "Write one step per line",
    recipeNamePlaceholder: "Example: Homestyle Vegetable Pasta",
    rateRecipe: "Rate this recipe",
    socialInfo: "Sign in with Google or use the configured admin access code for the admin panel.",
    favoriteAdd: "Add to favorites",
    favoriteRemove: "Remove from favorites",
    favoriteAdded: "Added to favorites",
    favoriteRemoved: "Removed from favorites",
    back: "Back",
    backToMeals: "Back to Meals",
    noMealSelected: "No meal selected",
    addAllIngredients: "Add Ingredients to List",
    addToList: "+ List",
    added: "Added",
    alreadyOnList: "Already on the list",
    ingredientAdded: "added to the list",
    ingredientsAddedToShopping: "ingredients added to the shopping list",
    videoRecipe: "Video Recipe",
    rateLoginRequired: "Sign in with a social account to rate.",
    ratingSaved: "Rating saved",
    noRatingYet: "No ratings yet",
    dietitianIntro: "Short, practical nutrition and lifestyle guidance every day.",
    dailyNutritionAdvice: "Daily nutrition and lifestyle advice",
    dailyTips: "Today's tips",
    suggestedFoodToday: "Suggested food today:",
    adviceLoading: "Preparing today's advice...",
    adviceLoadFailed: "Advice could not be loaded",
    checkBackendOrKey: "Check the backend connection or API key.",
    askDietitian: "Ask the Dietitian",
    medicalDisclaimer: "This section is for general information and does not replace personal diagnosis or treatment.",
    askPlaceholder: "Example: What can I choose for a lighter dinner?",
    answerPreparing: "Preparing an answer...",
    cannotAnswerNow: "I cannot answer right now. Please try again shortly.",
    wait: "Wait",
    ask: "Ask",
    favoritesIntro: "Quickly reach the meals and desserts you liked.",
    noFavorites: "No favorite recipes yet",
    favoriteHint: "Tap the heart on recipe cards to add favorites.",
    browseMeals: "Browse Meals",
    favoriteRecipeCount: "favorite recipes",
    shoppingIntro: "Keep track of missing ingredients added from recipes.",
    list: "List",
    waiting: "waiting",
    completed: "completed",
    clearCompleted: "Clear Completed",
    emptyList: "List is empty",
    shoppingEmptyHint: "Add ingredients from recipe detail pages.",
    purchased: "Purchased",
    addNewIngredient: "Add new ingredient...",
    add: "Add",
    delete: "Delete",
    purchasedCleared: "Purchased items cleared",
    ingredientSuggest: "Suggest by Ingredients",
    ingredientSuggestIntro: "Enter what you have and we will find suitable recipes.",
    yourIngredients: "Your Ingredients",
    addIngredientPlaceholder: "Add ingredient (example: tomato, egg...)",
    searching: "Searching...",
    findRecipe: "Find Recipes",
    clear: "Clear",
    searchingRecipes: "Searching recipes...",
    recipesFound: "recipes found",
    noMatchingRecipe: "No matching recipes found",
    tryDifferentIngredients: "Try different ingredients.",
    match: "Match",
    availableIngredients: "ingredients available",
    missingIngredients: "Missing ingredients:",
    addMissingToList: "Add Missing to List",
    exactMatches: "Exact matches",
    partialMatches: "Recipes with missing ingredients",
    aiIngredientHelp: "AI chef insight",
    aiIngredientResult: "AI chef insight",
    ingredientAiLocked: "AI suggestion locked",
    ingredientAiLockedHint: "If you are not premium, you can watch a rewarded ad for up to 3 AI suggestions per day.",
    ingredientAiRewardConfirm: "You will watch a rewarded ad simulation to earn 1 AI ingredient suggestion. Continue?",
    watchAdForAi: "Watch ad for AI suggestion",
    continueWith: "Continue with",
    requestFailed: "Request failed",
    translationQueued: "Full recipe translation is being prepared in the background; reopen shortly to see it.",
    translationNeedsKey: "Full recipe translation needs GROQ_API_KEY; categories and labels are localized.",
    admin: "Admin",
    adminPanel: "Admin Panel",
    adminPanelIntro: "New user recipes are submitted for administrator review; approve suitable content or reject it here.",
    adminAccessRequired: "Admin sign-in required",
    adminAccessHint: "This section opens only for the account matching ADMIN_EMAIL.",
    loading: "Loading...",
    refresh: "Refresh",
    status: "Status",
    active: "Active",
    inactive: "Passive",
    testUsersTitle: "Test Users",
    testUsersHint: "Track Google Play closed-test users, sessions, and last-14-day activity.",
    testUsersFilter: "Filter",
    testUserFilterall: "All users",
    testUserFilteractive: "Active users",
    testUserFilterinactive: "Passive users",
    testUserFilterrecent14: "Active in last 14 days",
    testUsersTotal: "Total registered users",
    testUsersLoggedIn: "Logged in at least once",
    testUsersActive14: "Active in last 14 days",
    testUsersOpenSessions: "Open sessions",
    testUsersNeverLoggedIn: "Never logged in",
    testUserEmail: "Email",
    testUserId: "User ID",
    testUserFirstLogin: "First login",
    testUserLastActive: "Last active",
    testUserSessionCount: "Total sessions",
    testUserSessionStatus: "Session",
    testUserSessionOpen: "Open",
    testUserSessionClosed: "Closed",
    testUserActiveDays14: "Active days in last 14",
    noTestUsers: "No test users match this filter.",
    pending: "Legacy pending",
    approved: "Published",
    rejected: "Unpublished",
    loadingRecipes: "Loading recipes...",
    noModerationRecipes: "No recipes to review",
    noModerationRecipesHint: "There are no recipes in this status.",
    approve: "Publish",
    reject: "Unpublish",
    preview: "Preview",
    recipeApproved: "Recipe published",
    recipeRejected: "Recipe unpublished",
    unpublishRecipe: "Unpublish",
    republishRecipe: "Publish again",
    recipeUnpublished: "Recipe unpublished",
    recipeRepublished: "Recipe published again",
    recipePendingReview: "Recipe saved and sent for administrator review.",
    emailAddress: "Email address",
    displayName: "Display name",
    recipeImage: "Recipe image",
    recipeImageHint: "JPG, PNG, or WEBP; max 2 MB.",
    changeImage: "Change image",
    recipeImageUpdated: "Recipe image updated",
    recipeMediaUpdated: "Recipe media updated",
    removeImage: "Remove main image",
    removeVideo: "Remove video",
    removeStepImages: "Remove step images",
    recipeImageRemoved: "Main image removed",
    recipeVideoRemoved: "Video removed",
    recipeStepImagesRemoved: "Step images removed",
    saveChanges: "Save changes",
    recipeContentUpdated: "Recipe content updated",
    recipeContentRequired: "Content fields may be left empty to remove the published text.",
    recipeSource: "Source",
    sourceImageNotImported: "Source image was not imported.",
    themealdbImportTitle: "TheMealDB import",
    themealdbImportHint: "Recipe text and ingredients are imported from the official API and saved in natural Turkish; TheMealDB images are not imported.",
    themealdbImportLetter: "Letter",
    themealdbImportLimit: "Count",
    themealdbImportButton: "Import from TheMealDB",
    themealdbImportDone: "TheMealDB recipes imported",
    copyrightReportTitle: "Report copyright infringement",
    copyrightReportButton: "Report copyright infringement",
    copyrightReportHint: "If this recipe contains an image, video, or text that belongs to you, you can notify us here.",
    copyrightReportReviewNote: "Your report will be technically reviewed; after review, the relevant content will be removed within 48 hours at the latest.",
    copyrightReporterName: "Name / organization",
    copyrightReporterEmail: "Your email address",
    copyrightIssueItems: "Infringing items",
    copyrightIssueItemsPlaceholder: "Example: main image, video, step images, recipe text",
    copyrightReferenceUrl: "Ownership / source link",
    copyrightDetails: "Details",
    copyrightDetailsPlaceholder: "Briefly explain why you are reporting this content.",
    copyrightReportSubmit: "Submit report",
    copyrightReportSubmitted: "Copyright report received",
    copyrightReportRequired: "Email and infringing items are required.",
    copyrightReports: "Copyright reports",
    copyrightReportsHint: "Rights-holder reports are tracked here.",
    noCopyrightReports: "No new copyright reports.",
    markReviewing: "Reviewing",
    markRemoved: "Removed",
    markDismissed: "Dismiss",
    close: "Close",
    legalTitle: "Privacy and Legal",
    legalOpen: "Open",
    legalProfileHint: "Privacy policy, terms, ad preferences, and copyright process.",
    legalIntro: "This page summarizes how the app handles data, ads, user content, and copyright notices.",
    legalLastUpdated: "Last updated: May 19, 2026",
    legalPrivacyTitle: "Privacy policy and data notice",
    legalPrivacyBody: "The app may process data such as name, email, profile details, height, weight, health background, allergies, medication notes, recipe text, images, videos, comments, ad preferences, and usage choices when you create an account, add recipes, comment, use AI features, or manage ads.",
    legalDataTitle: "How data is used",
    legalDataBody: "Data is used for account features, recipes, comments, shopping lists, favorites, AI diet assistant guidance, nutrition estimates, rewarded ad credits, security, troubleshooting, and improving service quality.",
    legalAiTitle: "AI and health information",
    legalAiBody: "The AI diet assistant does not diagnose, treat, or make medical decisions. Height, weight, health background, allergy, and medication details are used only as short context for safer general nutrition guidance.",
    legalAdsTitle: "Ads and ad preferences",
    legalAdsBody: "The app may show rewarded ads and interstitial ads through Google AdMob. Free users who allow ads can use selected AI and analysis features with ad-based credits. In production, ad consent should be handled through the Google AdMob UMP flow; premium users continue without ads.",
    legalUserContentTitle: "User recipes and content responsibility",
    legalUserContentBody: "Users who add recipes are responsible for the legality of recipe text, images, videos, step images, and links they share. New user recipes are published after administrator review.",
    legalThirdPartyRecipeTitle: "Third-party recipe sources",
    legalThirdPartyRecipeBody: "Recipes added from official API sources such as TheMealDB keep their source information. Images from these sources are not imported; images are generated in the app or added separately by an administrator.",
    legalCopyrightTitle: "Copyright notice process",
    legalCopyrightBody: "Rights holders can use the Report copyright infringement button on recipe details to report main images, videos, step images, recipe text, or other items. Reports are technically reviewed; after review, the relevant content is removed within 48 hours at the latest.",
    legalRightsTitle: "User rights and contact",
    legalRightsBody: "Users may request correction, deletion, or account closure. These requests and copyright/content notices can be sent to the app administrator or support contact address.",
    legalDisclaimerTitle: "Legal note",
    legalDisclaimerBody: "This is an in-app information draft. Before launch, the privacy policy, terms, ad consent text, and Google Play Data Safety declarations should be made consistent and, if needed, reviewed by a legal professional.",
    designSettings: "Design Settings",
    designSettingsIntro: "Change the app title, fonts, text size, button colors, and menu icons.",
    interstitialAdMessage: "Interstitial ad simulation. In the real mobile version, a short interstitial ad will be shown here.",
    appTitle: "App title",
    bodyFont: "Body font",
    headingFont: "Heading font",
    baseFontSize: "Base font size",
    headingScale: "Heading scale",
    buttonRadius: "Button corner radius",
    primaryButtonColor: "Primary button color",
    primaryButtonHover: "Primary hover color",
    successButtonColor: "Green button color",
    buttonTextColor: "Button text color",
    saveDesignSettings: "Save design",
    designSettingsSaved: "Design settings saved",
  },
};

const FALLBACKS = {
  de: { brand: "FitDish", daily: "Tagesplan", meals: "Gerichte", desserts: "Desserts", addRecipe: "Rezept hinzufügen", favorites: "Favoriten", shopping: "Einkauf", dietitian: "Online-Ernährungsberater", signIn: "Anmelden", signOut: "Abmelden", language: "Sprache", healthy: "Gesund", tasty: "Lecker", balanced: "Ausgewogen", breakfast: "Frühstück", lunch: "Mittagessen", dinner: "Abendessen", dessert: "Dessert", cuisine: "Küche", category: "Kategorie", meal: "Mahlzeit", saveRecipe: "Rezept speichern", youtubeUrl: "YouTube-Videolink", loginRequiredRecipe: "Melden Sie sich an, um ein Rezept hinzuzufügen." },
  it: { brand: "FitDish", daily: "Piano giornaliero", meals: "Piatti", desserts: "Dolci", addRecipe: "Aggiungi ricetta", favorites: "Preferiti", shopping: "Spesa", dietitian: "Dietista online", signIn: "Accedi", signOut: "Esci", language: "Lingua", healthy: "Sano", tasty: "Gustoso", balanced: "Equilibrato", breakfast: "Colazione", lunch: "Pranzo", dinner: "Cena", dessert: "Dolce", cuisine: "Cucina", category: "Categoria", meal: "Pasto", saveRecipe: "Salva ricetta", youtubeUrl: "Link video YouTube", loginRequiredRecipe: "Accedi per aggiungere una ricetta." },
  pt: { brand: "FitDish", daily: "Plano diário", meals: "Pratos", desserts: "Sobremesas", addRecipe: "Adicionar receita", favorites: "Favoritos", shopping: "Compras", dietitian: "Nutricionista online", signIn: "Entrar", signOut: "Sair", language: "Idioma", healthy: "Saudável", tasty: "Saboroso", balanced: "Equilibrado", breakfast: "Café da manhã", lunch: "Almoço", dinner: "Jantar", dessert: "Sobremesa", cuisine: "Cozinha", category: "Categoria", meal: "Refeição", saveRecipe: "Salvar receita", youtubeUrl: "Link do vídeo do YouTube", loginRequiredRecipe: "Entre para adicionar uma receita." },
  es: { brand: "FitDish", daily: "Plan diario", meals: "Comidas", desserts: "Postres", addRecipe: "Añadir receta", favorites: "Favoritos", shopping: "Compras", dietitian: "Dietista online", signIn: "Entrar", signOut: "Salir", language: "Idioma", healthy: "Saludable", tasty: "Sabroso", balanced: "Equilibrado", breakfast: "Desayuno", lunch: "Almuerzo", dinner: "Cena", dessert: "Postre", cuisine: "Cocina", category: "Categoría", meal: "Comida", saveRecipe: "Guardar receta", youtubeUrl: "Enlace de video de YouTube", loginRequiredRecipe: "Inicia sesión para añadir una receta." },
  fr: { brand: "FitDish", daily: "Plan du jour", meals: "Plats", desserts: "Desserts", addRecipe: "Ajouter une recette", favorites: "Favoris", shopping: "Courses", dietitian: "Diététicien en ligne", signIn: "Connexion", signOut: "Déconnexion", language: "Langue", healthy: "Sain", tasty: "Savoureux", balanced: "Équilibré", breakfast: "Petit-déjeuner", lunch: "Déjeuner", dinner: "Dîner", dessert: "Dessert", cuisine: "Cuisine", category: "Catégorie", meal: "Repas", saveRecipe: "Enregistrer la recette", youtubeUrl: "Lien vidéo YouTube", loginRequiredRecipe: "Connectez-vous pour ajouter une recette." },
  ja: { brand: "FitDish", daily: "毎日の献立", meals: "料理", desserts: "デザート", addRecipe: "レシピ追加", favorites: "お気に入り", shopping: "買い物", dietitian: "オンライン栄養士", signIn: "ログイン", signOut: "ログアウト", language: "言語", healthy: "ヘルシー", tasty: "おいしい", balanced: "バランス", breakfast: "朝食", lunch: "昼食", dinner: "夕食", dessert: "デザート", cuisine: "料理ジャンル", category: "カテゴリ", meal: "食事", saveRecipe: "レシピを保存", youtubeUrl: "YouTube動画リンク", loginRequiredRecipe: "レシピを追加するにはログインしてください。" },
  zh: { brand: "FitDish", daily: "每日菜单", meals: "菜肴", desserts: "甜点", addRecipe: "添加食谱", favorites: "收藏", shopping: "购物", dietitian: "在线营养师", signIn: "登录", signOut: "退出", language: "语言", healthy: "健康", tasty: "美味", balanced: "均衡", breakfast: "早餐", lunch: "午餐", dinner: "晚餐", dessert: "甜点", cuisine: "菜系", category: "类别", meal: "餐次", saveRecipe: "保存食谱", youtubeUrl: "YouTube 视频链接", loginRequiredRecipe: "请登录后添加食谱。" },
  ko: { brand: "FitDish", daily: "일일 식단", meals: "요리", desserts: "디저트", addRecipe: "레시피 추가", favorites: "즐겨찾기", shopping: "장보기", dietitian: "온라인 영양사", signIn: "로그인", signOut: "로그아웃", language: "언어", healthy: "건강식", tasty: "맛있는", balanced: "균형식", breakfast: "아침", lunch: "점심", dinner: "저녁", dessert: "디저트", cuisine: "요리권", category: "카테고리", meal: "식사", saveRecipe: "레시피 저장", youtubeUrl: "YouTube 영상 링크", loginRequiredRecipe: "레시피를 추가하려면 로그인하세요." },
  ru: { brand: "FitDish", daily: "План на день", meals: "Блюда", desserts: "Десерты", addRecipe: "Добавить рецепт", favorites: "Избранное", shopping: "Покупки", dietitian: "AI-ассистент по питанию", signIn: "Войти", signOut: "Выйти", language: "Язык", healthy: "Полезное", tasty: "Вкусное", balanced: "Сбалансированное", breakfast: "Завтрак", lunch: "Обед", dinner: "Ужин", dessert: "Десерт", cuisine: "Кухня", category: "Категория", meal: "Прием пищи", saveRecipe: "Сохранить рецепт", youtubeUrl: "Ссылка на видео YouTube", loginRequiredRecipe: "Войдите, чтобы добавить рецепт." },
  sv: { brand: "FitDish", daily: "Dagsplan", meals: "Maträtter", desserts: "Desserter", addRecipe: "Lägg till recept", favorites: "Favoriter", shopping: "Inköp", dietitian: "AI-kostassistent", signIn: "Logga in", signOut: "Logga ut", language: "Språk", healthy: "Hälsosam", tasty: "God", balanced: "Balanserad", breakfast: "Frukost", lunch: "Lunch", dinner: "Middag", dessert: "Efterrätt", cuisine: "Kök", category: "Kategori", meal: "Måltid", saveRecipe: "Spara recept", youtubeUrl: "YouTube-videolänk", loginRequiredRecipe: "Logga in för att lägga till ett recept." },
  da: { brand: "FitDish", daily: "Dagsplan", meals: "Retter", desserts: "Desserter", addRecipe: "Tilføj opskrift", favorites: "Favoritter", shopping: "Indkøb", dietitian: "AI-kostassistent", signIn: "Log ind", signOut: "Log ud", language: "Sprog", healthy: "Sund", tasty: "Lækker", balanced: "Balanceret", breakfast: "Morgenmad", lunch: "Frokost", dinner: "Aftensmad", dessert: "Dessert", cuisine: "Køkken", category: "Kategori", meal: "Måltid", saveRecipe: "Gem opskrift", youtubeUrl: "YouTube-videolink", loginRequiredRecipe: "Log ind for at tilføje en opskrift." },
  no: { brand: "FitDish", daily: "Dagsplan", meals: "Retter", desserts: "Desserter", addRecipe: "Legg til oppskrift", favorites: "Favoritter", shopping: "Handleliste", dietitian: "AI-kostassistent", signIn: "Logg inn", signOut: "Logg ut", language: "Språk", healthy: "Sunn", tasty: "God", balanced: "Balansert", breakfast: "Frokost", lunch: "Lunsj", dinner: "Middag", dessert: "Dessert", cuisine: "Kjøkken", category: "Kategori", meal: "Måltid", saveRecipe: "Lagre oppskrift", youtubeUrl: "YouTube-videolink", loginRequiredRecipe: "Logg inn for å legge til en oppskrift." },
  nl: { brand: "FitDish", daily: "Dagplan", meals: "Gerechten", desserts: "Desserts", addRecipe: "Recept toevoegen", favorites: "Favorieten", shopping: "Boodschappen", dietitian: "AI-dieetassistent", signIn: "Inloggen", signOut: "Uitloggen", language: "Taal", healthy: "Gezond", tasty: "Lekker", balanced: "Gebalanceerd", breakfast: "Ontbijt", lunch: "Lunch", dinner: "Diner", dessert: "Dessert", cuisine: "Keuken", category: "Categorie", meal: "Maaltijd", saveRecipe: "Recept opslaan", youtubeUrl: "YouTube-videolink", loginRequiredRecipe: "Log in om een recept toe te voegen." },
  el: { brand: "FitDish", daily: "Ημερήσιο πλάνο", meals: "Γεύματα", desserts: "Επιδόρπια", addRecipe: "Προσθήκη συνταγής", favorites: "Αγαπημένα", shopping: "Αγορές", dietitian: "AI βοηθός διατροφής", signIn: "Σύνδεση", signOut: "Αποσύνδεση", language: "Γλώσσα", healthy: "Υγιεινό", tasty: "Νόστιμο", balanced: "Ισορροπημένο", breakfast: "Πρωινό", lunch: "Μεσημεριανό", dinner: "Βραδινό", dessert: "Επιδόρπιο", cuisine: "Κουζίνα", category: "Κατηγορία", meal: "Γεύμα", saveRecipe: "Αποθήκευση συνταγής", youtubeUrl: "Σύνδεσμος βίντεο YouTube", loginRequiredRecipe: "Συνδεθείτε για να προσθέσετε συνταγή." },
};

const PROFILE_TRANSLATIONS = {
  tr: {
    myProfile: "Profil Bilgilerim",
    profileIntro: "Boy, kilo ve sağlık geçmişinizi kaydedin; ideal kilo aralığınız hesaplansın ve online diyetisyen bunu dikkate alsın.",
    profileLoginRequired: "Profil için giriş yapın",
    profileLoginHint: "Boy ve kilo bilgileri sadece giriş yapan kullanıcı hesabına kaydedilir.",
    heightCm: "Boy (cm)",
    weightKg: "Kilo (kg)",
    pastIllnesses: "Geçirdiğiniz hastalıklar",
    pastIllnessesPlaceholder: "Örn: ameliyat, ciddi enfeksiyon, geçmiş önemli rahatsızlıklar",
    chronicDiseases: "Kronik hastalıklar",
    chronicDiseasesPlaceholder: "Örn: diyabet, hipertansiyon, tiroid, çölyak",
    allergies: "Alerjiler / intoleranslar",
    allergiesPlaceholder: "Örn: fıstık alerjisi, laktoz intoleransı, gluten hassasiyeti",
    medications: "Düzenli ilaçlar / takviyeler",
    medicationsPlaceholder: "Örn: doktor kontrolünde kullanılan ilaçlar veya takviyeler",
    healthProfilePrivacyNote: "Bu bilgiler yalnızca daha dikkatli genel öneriler için kısa özet olarak kullanılır; tanı veya tedavi yerine geçmez.",
    saveProfile: "Profili Kaydet",
    profileSaved: "Profil bilgileri kaydedildi",
    idealWeightResult: "İdeal kilo hesaplaması",
    idealWeightRange: "Sağlıklı kilo aralığı",
    bmi: "VKİ",
    bmiCategory: "VKİ durumu",
    neutralTarget: "Orta hedef",
    underweight: "Zayıf",
    overweight: "Fazla kilolu",
    obese: "Obezite aralığı",
    enterHeightWeight: "Boy ve kilo girin",
    enterHeightWeightHint: "Hesaplama için iki bilgi de gerekli.",
    profileDietitianNote: "Online diyetisyen, soru sorarken bu profil özetini maliyet artırmadan kısa bağlam olarak kullanır.",
    profileLinkedToDietitian: "Profiliniz diyetisyene bağlı",
    medicalProfileLinked: "sağlık geçmişi kayıtlı",
    profileNotCompleted: "Profil bilgileri eksik",
    profileNotCompletedHint: "Profil bölümünden boy ve kilo girerseniz öneriler daha kişisel olur.",
    weeklyProgress: "Haftalık Gelişim",
    weeklyProgressIntro: "Her hafta boy ve kilo ölçümünü kaydet; gelişimini grafik ve AI yorumu ile takip et.",
    weekStart: "Hafta başlangıcı",
    saveWeeklyMeasurement: "Haftalık Ölçümü Kaydet",
    weeklyMeasurementSaved: "Haftalık ölçüm kaydedildi",
    noWeeklyData: "Henüz haftalık veri yok",
    noWeeklyDataHint: "İlk haftalık ölçümünü kaydedince grafik oluşur.",
    getWeeklyAiReview: "Haftalık AI Değerlendirmesi Al",
    aiWeeklyReview: "AI haftalık değerlendirme",
    weeklyReviewCached: "Bu haftanın değerlendirmesi kayıttan getirildi",
    weeklyReviewGenerated: "Bu haftanın değerlendirmesi oluşturuldu",
    weeklyMeasurements: "Haftalık ölçümler",
    weeklyProgressReport: "Haftalık gelişim raporu",
    generatedAt: "Oluşturulma tarihi",
    recommendations: "Öneriler",
    focusNextWeek: "Gelecek hafta odağı",
    downloadPdf: "PDF İndir",
    recipeDetailRewardConfirm: "Bugünkü 2 ücretsiz tarif detayı hakkınız bitti. Bu tarifi açmak için ödüllü reklam izlemek ister misiniz?",
    markMealEaten: "Bu yemeği yaptım / yedim",
    mealLoggedToday: "Bugün yendi olarak işaretlendi",
    mealLogHint: "Bu bilgi diyetisyenin son beslenme düzeninizi daha iyi yorumlamasına yardım eder.",
    iAteThis: "Yedim / Yaptım",
    undoMealLog: "Geri Al",
    mealLogged: "Yemek günlüğüne kaydedildi",
    mealLogRemoved: "Yemek günlüğünden kaldırıldı",
    mealLogLoginRequired: "Yediğiniz yemekleri kaydetmek için giriş yapın.",
    nutrition: "Besin Değerleri",
    nutritionIntro: "Yiyecekleri 100 gram için kalori, makro, mineral, vitamin ve günlük ihtiyaç yüzdesiyle inceleyin.",
    nutritionSearchPlaceholder: "Örn: yumurta, yoğurt, avokado...",
    searchNutrition: "Besin Ara",
    refreshFromSources: "Kaynaktan Yenile",
    nutritionLoading: "Besin değerleri aranıyor...",
    nutritionPer100g: "100 gram için değerler",
    nutritionConfidenceHigh: "Yüksek güven",
    nutritionConfidenceMedium: "Orta güven",
    nutritionConfidenceLow: "Düşük güven",
    viewSource: "Kaynağı aç",
    vitaminsMinerals: "Vitamin ve mineraller",
    dailyValueChart: "Günlük ihtiyaçı karşılama",
    macroDistribution: "Makro dağılımı",
    nutritionNotFound: "Besin değeri bulunamadı",
    nutritionNotFoundHint: "Farklı veya daha genel bir yiyecek adı deneyin.",
    mealNutritionEstimate: "Yemek Kalori Hesaplayıcı",
    mealNutritionEstimateHint: "Yaptığınız yemeğin malzemelerini gramajıyla girin; toplam kalori ve makroları hesaplayalım.",
    mealIngredientsPlaceholder: "Her satıra malzeme ve gram yazın: yumurta, 100",
    ingredientGramFormat: "Format: malzeme, gram",
    calculateMealNutrition: "Yemeği Hesapla",
    calculating: "Hesaplanıyor...",
    mealNutritionLimitReached: "Yazılı besin hesaplama hakkınız bitti",
    mealNutritionLimitHint: "Ödüllü reklam izleyerek ek besin hesaplama hakkı alabilirsiniz.",
    mealNutritionRewardConfirm: "Yazılı besin hesaplama için kısa bir ödüllü reklam izleyerek 1 ek hak kazanacaksınız. Devam edilsin mi?",
    watchAdForMealEstimate: "Reklam izle ve hesapla",
    photoNutritionEstimate: "Fotoğraftan Kalori Tahmini",
    photoNutritionEstimateHint: "Yemek fotoğrafını anında çekin veya galeriden seçin; AI yaklaşık porsiyon, kalori ve makro tahmini sunsun.",
    photoSourceHint: "Kamerayla çekin veya galeriden yemek fotoğrafı seçin",
    takeMealPhoto: "Kamerayla Çek",
    chooseFromGallery: "Galeriden Seç",
    changeMealPhoto: "Fotoğrafı Değiştir",
    chooseMealPhoto: "Yemek fotoğrafı seç",
    estimateFromPhoto: "Fotoğraftan Tahmin Et",
    analyzingPhoto: "Fotoğraf analiz ediliyor...",
    photoEstimateWarning: "Sonuç yaklaşık tahmindir.",
    estimatedNutrition: "Tahmini besin değeri",
    estimatedServing: "Tahmini porsiyon",
    photoNutritionRewardConfirm: "Fotoğraftan kalori tahmini için kısa bir ödüllü reklam izleyerek 1 ek hak kazanacaksınız. Devam edilsin mi?",
    photoNutritionLimitReached: "Fotoğraf analizi hakkınız bitti",
    photoNutritionLimitHint: "Premium değilseniz ödüllü reklam izleyerek ek fotoğraf analizi hakkı alabilirsiniz.",
    watchAdForPhotoEstimate: "Reklam izle ve fotoğrafı analiz et",
    usageLimitSettings: "Günlük Kullanım Limitleri",
    usageType: "Kullanım türü",
    guestFree: "Misafir ücretsiz",
    userFree: "Üye ücretsiz",
    premiumFree: "Premium",
    guestRewardMax: "Misafir reklamlı",
    userRewardMax: "Üye reklamlı",
    dietitian_question: "AI diyetisyen sorusu",
    diet_plan_action: "AI diyet planı oluşturma/düzenleme",
    daily_plan_refresh: "Yeni günlük plan",
    personalized_daily_plan: "Profile göre AI plan",
    ingredient_ai_suggest: "AI malzeme önerisi",
    ingredient_recipe_search: "Malzemeden tarif arama",
    recipe_detail_view: "Tarif detay açma",
    photo_nutrition_estimate: "Fotoğraftan kalori tahmini",
    nutrition_text_estimate: "Yazılı besin hesaplama",
    nutrition_search: "Besin arama",
    fitness_plan: "Fitness planı",
    dailyRewardLimit: "Günlük ödüllü reklam limiti",
    appUpdateSettings: "Mobil Uygulama Güncelleme Ayarları",
    appUpdateEnabled: "Yeni sürüm uyarısını etkinleştir",
    appUpdateLatestVersion: "son sürüm",
    appUpdateMinimumVersion: "zorunlu minimum sürüm",
    appUpdateStoreUrl: "mağaza bağlantısı",
    interstitialSettings: "Geçiş Reklamı Ayarları",
    dailyGuestLimit: "Misafir günlük geçiş",
    dailyUserLimit: "Üye günlük geçiş",
    dailyPremiumLimit: "Premium günlük geçiş",
    minSessionAgeSeconds: "İlk bekleme (sn)",
    minGapSeconds: "Reklam arası (sn)",
    navTransitionThreshold: "Menü geçiş eşiği",
    ingredientSearchThreshold: "Malzeme arama eşiği",
    recipeDetailExitThreshold: "Tarif çıkış eşiği",
    adMobSafetySettings: "AdMob Güvenlik Ayarları",
    consentRequired: "Reklam onayı zorunlu",
    requireSsvInProduction: "Canlı ortamda SSV zorunlu",
    appAdsTxtRequired: "app-ads.txt zorunlu",
    appAdsTxtPublisherId: "AdMob publisher ID",
    adConsentTitle: "Reklam tercihiniz",
    adConsentText: "Sonuç sonrası doğal geçişlerde standart geçiş reklamı gösterebilmek için reklam tercihinizi seçin. Bu tercih mobil sürümde AdMob onay akışına bağlanır.",
    acceptPersonalizedAds: "Kişiselleştirilmiş reklama izin ver",
    acceptNonPersonalizedAds: "Sadece kişiselleştirilmemiş reklam"
  },
  en: {
    myProfile: "My Profile",
    profileIntro: "Save your height, weight, and health background; your healthy weight range is calculated and the online dietitian can use it.",
    profileLoginRequired: "Sign in for your profile",
    profileLoginHint: "Height and weight are saved only to signed-in user accounts.",
    heightCm: "Height (cm)",
    weightKg: "Weight (kg)",
    pastIllnesses: "Past illnesses",
    pastIllnessesPlaceholder: "Example: surgery, serious infection, important past conditions",
    chronicDiseases: "Chronic conditions",
    chronicDiseasesPlaceholder: "Example: diabetes, hypertension, thyroid condition, celiac disease",
    allergies: "Allergies / intolerances",
    allergiesPlaceholder: "Example: peanut allergy, lactose intolerance, gluten sensitivity",
    medications: "Regular medications / supplements",
    medicationsPlaceholder: "Example: medicines or supplements used under professional guidance",
    healthProfilePrivacyNote: "These details are used only as a short context for safer general guidance; they are not a diagnosis or treatment.",
    saveProfile: "Save Profile",
    profileSaved: "Profile saved",
    idealWeightResult: "Healthy weight calculation",
    idealWeightRange: "Healthy weight range",
    bmi: "BMI",
    bmiCategory: "BMI status",
    neutralTarget: "Middle target",
    underweight: "Underweight",
    overweight: "Overweight",
    obese: "Obesity range",
    enterHeightWeight: "Enter height and weight",
    enterHeightWeightHint: "Both values are needed for the calculation.",
    profileDietitianNote: "When you ask a question, the online dietitian uses this short profile summary without changing the cost controls.",
    profileLinkedToDietitian: "Your profile is linked to the dietitian",
    medicalProfileLinked: "medical profile saved",
    profileNotCompleted: "Profile is incomplete",
    profileNotCompletedHint: "Add height and weight in your profile for more personal guidance.",
    weeklyProgress: "Weekly Progress",
    weeklyProgressIntro: "Save weekly height and weight measurements; track progress with charts and AI feedback.",
    weekStart: "Week start",
    saveWeeklyMeasurement: "Save Weekly Measurement",
    weeklyMeasurementSaved: "Weekly measurement saved",
    noWeeklyData: "No weekly data yet",
    noWeeklyDataHint: "Save your first weekly measurement to create the chart.",
    getWeeklyAiReview: "Get Weekly AI Review",
    aiWeeklyReview: "AI weekly review",
    weeklyReviewCached: "This week's review was loaded from cache",
    weeklyReviewGenerated: "This week's review was generated",
    weeklyMeasurements: "Weekly measurements",
    weeklyProgressReport: "Weekly progress report",
    generatedAt: "Generated at",
    recommendations: "Recommendations",
    focusNextWeek: "Next week focus",
    downloadPdf: "Download PDF",
    recipeDetailRewardConfirm: "Your 2 free recipe detail views for today are used. Watch a rewarded ad to open this recipe?",
    markMealEaten: "I made / ate this",
    mealLoggedToday: "Marked as eaten today",
    mealLogHint: "This helps the dietitian understand your recent eating pattern better.",
    iAteThis: "I Ate This",
    undoMealLog: "Undo",
    mealLogged: "Saved to your meal log",
    mealLogRemoved: "Removed from your meal log",
    mealLogLoginRequired: "Sign in to save eaten meals.",
    nutrition: "Nutrition Facts",
    nutritionIntro: "Review calories, macros, minerals, vitamins, and daily value percentages per 100 grams.",
    nutritionSearchPlaceholder: "Example: egg, yogurt, avocado...",
    searchNutrition: "Search Nutrition",
    refreshFromSources: "Refresh from Sources",
    nutritionLoading: "Searching nutrition data...",
    nutritionPer100g: "Values per 100 grams",
    nutritionConfidenceHigh: "High confidence",
    nutritionConfidenceMedium: "Medium confidence",
    nutritionConfidenceLow: "Low confidence",
    viewSource: "Open source",
    vitaminsMinerals: "Vitamins and minerals",
    dailyValueChart: "Daily value coverage",
    macroDistribution: "Macro distribution",
    nutritionNotFound: "No nutrition data found",
    nutritionNotFoundHint: "Try a different or more general food name.",
    mealNutritionEstimate: "Meal Calorie Calculator",
    mealNutritionEstimateHint: "Enter the ingredients and grams for your cooked meal to estimate total calories and macros.",
    mealIngredientsPlaceholder: "Write one ingredient and grams per line: egg, 100",
    ingredientGramFormat: "Format: ingredient, grams",
    calculateMealNutrition: "Calculate Meal",
    calculating: "Calculating...",
    mealNutritionLimitReached: "Meal calculation limit reached",
    mealNutritionLimitHint: "Watch a rewarded ad to earn another meal calculation.",
    mealNutritionRewardConfirm: "Watch a short rewarded ad to earn 1 extra meal calculation. Continue?",
    watchAdForMealEstimate: "Watch ad and calculate",
    photoNutritionEstimate: "Photo Calorie Estimate",
    photoNutritionEstimateHint: "Take a fresh meal photo or choose one from your gallery; AI will estimate portion, calories, and macros.",
    photoSourceHint: "Take a photo or choose a meal photo from your gallery",
    takeMealPhoto: "Take Photo",
    chooseFromGallery: "Choose from Gallery",
    changeMealPhoto: "Change Photo",
    chooseMealPhoto: "Choose meal photo",
    estimateFromPhoto: "Estimate from Photo",
    analyzingPhoto: "Analyzing photo...",
    photoEstimateWarning: "Result is an approximate estimate.",
    estimatedNutrition: "Estimated nutrition",
    estimatedServing: "Estimated serving",
    photoNutritionRewardConfirm: "Watch a short rewarded ad to earn 1 extra photo calorie estimate. Continue?",
    photoNutritionLimitReached: "Photo analysis limit reached",
    photoNutritionLimitHint: "If you are not premium, watch a rewarded ad to earn another photo analysis.",
    watchAdForPhotoEstimate: "Watch ad and analyze photo",
    usageLimitSettings: "Daily Usage Limits",
    usageType: "Usage type",
    guestFree: "Guest free",
    userFree: "User free",
    premiumFree: "Premium",
    guestRewardMax: "Guest rewarded",
    userRewardMax: "User rewarded",
    dietitian_question: "AI dietitian question",
    diet_plan_action: "AI diet plan create/refine",
    daily_plan_refresh: "New daily plan",
    personalized_daily_plan: "Profile-based AI plan",
    ingredient_ai_suggest: "AI ingredient suggestion",
    ingredient_recipe_search: "Ingredient recipe search",
    recipe_detail_view: "Recipe detail view",
    photo_nutrition_estimate: "Photo calorie estimate",
    nutrition_text_estimate: "Written nutrition estimate",
    nutrition_search: "Nutrition search",
    fitness_plan: "Fitness plan",
    dailyRewardLimit: "Daily rewarded ad limit",
    appUpdateSettings: "Mobile App Update Settings",
    appUpdateEnabled: "Enable new version prompt",
    appUpdateLatestVersion: "latest version",
    appUpdateMinimumVersion: "required minimum version",
    appUpdateStoreUrl: "store URL",
    interstitialSettings: "Interstitial Ad Settings",
    dailyGuestLimit: "Guest daily interstitials",
    dailyUserLimit: "User daily interstitials",
    dailyPremiumLimit: "Premium daily interstitials",
    minSessionAgeSeconds: "Initial delay (sec)",
    minGapSeconds: "Ad gap (sec)",
    navTransitionThreshold: "Menu transition threshold",
    ingredientSearchThreshold: "Ingredient search threshold",
    recipeDetailExitThreshold: "Recipe exit threshold",
    adMobSafetySettings: "AdMob Safety Settings",
    consentRequired: "Require ad consent",
    requireSsvInProduction: "Require SSV in production",
    appAdsTxtRequired: "Require app-ads.txt",
    appAdsTxtPublisherId: "AdMob publisher ID",
    adConsentTitle: "Ad preference",
    adConsentText: "Choose your ad preference so standard interstitial ads can be shown at natural transitions after a result. In the mobile version this connects to the AdMob consent flow.",
    acceptPersonalizedAds: "Allow personalized ads",
    acceptNonPersonalizedAds: "Non-personalized ads only"
  }
};

const I18nContext = createContext();

function detectLanguage() {
  const saved = localStorage.getItem("language");
  if (saved) return saved;
  const browser = navigator.language?.slice(0, 2).toLowerCase();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (browser === "tr" || timezone === "Europe/Istanbul") return "tr";
  return LANGUAGES.some((item) => item.code === browser) ? browser : "en";
}

export function I18nProvider({ children }) {
  const [language, setLanguageState] = useState(detectLanguage);

  useEffect(() => {
    localStorage.setItem("language", language);
    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  }, [language]);

  const value = useMemo(() => {
    const dict = { ...TEXT.en, ...PROFILE_TRANSLATIONS.en, ...(FALLBACKS[language] || {}), ...(EXTRA_TRANSLATIONS[language] || {}), ...(PROFILE_TRANSLATIONS[language] || {}), ...(TEXT[language] || {}) };
    return {
      language,
      languages: LANGUAGES,
      setLanguage: setLanguageState,
      t: (key) => dict[key] || TEXT.en[key] || key,
    };
  }, [language]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
